function isSameSiteReferrer(currentUrl, referrer) {
    if (!referrer || !currentUrl) {
        return false;
    }

    const domain = currentUrl.split('/').slice(0, 3).join('/');

    return referrer.startsWith(domain);
}

/**
 * Decide whether this page view should open the language popup, defer it, or skip it.
 * An excluded page keeps a pending flag so the next eligible page in the same tab can still show it.
 *
 * @param {{ disabled: boolean, flagSwitch: boolean, currentUrl: string, referrer: string, pending: boolean }} state
 * @returns {{ action: 'show' | 'skip', pending: boolean }}
 */
function resolveLanguagePopupGate(state) {
    if (state.flagSwitch) {
        return { action: 'skip', pending: false };
    }

    const owesPopup = !isSameSiteReferrer(state.currentUrl, state.referrer) || state.pending;

    if (state.disabled && owesPopup) {
        return { action: 'skip', pending: true };
    }

    if (state.disabled) {
        return { action: 'skip', pending: false };
    }

    if (owesPopup) {
        return { action: 'show', pending: false };
    }

    return { action: 'skip', pending: false };
}

module.exports = {
    isSameSiteReferrer,
    resolveLanguagePopupGate,
};
